module.exports = __webpack_public_path__ + "img/oxidation-reduction-potential.e2dc9e0c.jpg";